import { Injectable, NgZone, inject } from '@angular/core';

import { ClientConfigDiff, ClientConfigService, TrackingService, WINDOW } from '@frontend/vanilla/core';

import { __CLIENT_CONFIG_UPDATE_AVAILABLE__, __READ_CLIENT_CONFIG__, __TRACK__ } from '../../events';
import { IEventTrackingInput } from './event-tracking.input';

@Injectable({ providedIn: 'root' })
export class GlobalSearchWebTrackingService {
    private readonly trackingService = inject(TrackingService);
    private readonly clientConfigService = inject(ClientConfigService);
    private _ngZone = inject(NgZone);

    #window = inject(WINDOW);

    constructor() {
        this.clientConfigService.updates.subscribe((clientConfigDiff: ClientConfigDiff) => {
            this.#window.dispatchEvent(new CustomEvent(__CLIENT_CONFIG_UPDATE_AVAILABLE__, { detail: clientConfigDiff }));
        });
    }
    registerHandlers() {
        this.#window.addEventListener(__TRACK__, this.trackingHandler, false);
        this._ngZone.runOutsideAngular(() => {
            this.#window.addEventListener(__READ_CLIENT_CONFIG__, this.readClientConfighandler, false);
        });
    }

    trackingHandler = (customevent: Event) => {
        const trackingData = (customevent as CustomEvent)?.detail;
        if (trackingData) {
            const eventName = trackingData.eventName;
            const data = trackingData.data;
            const options = trackingData.options;
            this.trackingService.triggerEvent(eventName, data, options);
        }
    };

    readClientConfighandler = (customevent: Event) => {
        if ((customevent as CustomEvent)?.detail?.clientConfig) {
            (customevent as CustomEvent).detail.clientConfig = (window as any).clientConfig;
            // to read  clientconfig from vanilla
        }
    };

    trackClick(eventInput: IEventTrackingInput): void {
        this.trackEventDetail(eventInput);
    }

    trackTerm(eventInput: IEventTrackingInput): void {
        this.trackEventDetail(eventInput);
    }

    private trackEventDetail(eventInput: IEventTrackingInput): void {
        this.trackingService.triggerEvent('Event.Tracking', {
            'component.CategoryEvent': eventInput.componentCategoryEvent,
            'component.LabelEvent': eventInput.componentLabelEvent,
            'component.ActionEvent': eventInput.componentActionEvent,
            'component.PositionEvent': eventInput.componentPositionEvent,
            'component.LocationEvent': eventInput.componentLocationEvent,
            'component.EventDetails': eventInput.componentEventDetails,
            'component.URLClicked': eventInput.componentURLClicked,
        });
    }
}
